// extracted by mini-css-extract-plugin
export default {"icon":"PrintButton--icon--eb914b","print":"PrintButton--print--cf9aee"};